<div class="pm-editor">
  <!-- Solapas: una por pantalla -->
  <div class="tabs">
    @for (p of infoPantallas; track $index; let i = $index) {
      <button
        type="button"
        class="tab"
        [class.on]="pantalla === i"
        (click)="setPantalla(i)"
      >
        <span class="num">{{ i + 1 }}</span>
        <span class="txt">
          <strong>{{ p.titulo }}</strong>
          <small>{{ p.sub }}</small>
        </span>
        <span class="cuenta" [class.vacia]="!cantidadPiezas(i)">
          {{ cantidadPiezas(i) || "vacía" }}
        </span>
      </button>
    }
  </div>

  @if (!bloques.length) {
    <p class="vacio">
      @if (pantalla === 0) {
        La pantalla 1 no tiene piezas. Agregá al menos una pieza de botones.
      } @else {
        Pantalla vacía: el vecino no la ve. Agregale piezas si querés usarla.
      }
    </p>
  }
  @if (inalcanzable) {
    <p class="aviso">
      <mat-icon inline>info</mat-icon>
      No se llega a esta pantalla: agregá "Más" en una fila de la pantalla
      {{ pantalla }}.
    </p>
  }
  @if (masSinDestino) {
    <p class="aviso">
      <mat-icon inline>info</mat-icon>
      @if (pantalla === 2) {
        "Más" no hace nada en la pantalla 3 (es la última): no se va a ver.
      } @else {
        "Más" lleva a la pantalla {{ pantalla + 2 }}, que está vacía: no se va a
        ver hasta que le agregues piezas.
      }
    </p>
  }
  @if (sinAtras) {
    <p class="aviso suave">
      <mat-icon inline>info</mat-icon>
      Sin "Atrás" en una fila, el vecino vuelve solo con el botón atrás del
      teléfono.
    </p>
  }

  @for (b of bloques; track trackIndex($index); let i = $index, primero = $first, ultimo = $last) {
    <div class="bloque">
      <div class="bloque-head">
        <mat-icon class="tipo-ic">{{ tipo(b.tipo)?.icono }}</mat-icon>
        <strong>{{ i + 1 }}. {{ tipo(b.tipo)?.label }}</strong>
        <span class="flex"></span>
        <button
          mat-icon-button
          type="button"
          matTooltip="Subir"
          [disabled]="primero"
          (click)="mover(i, -1)"
        >
          <mat-icon>arrow_upward</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          matTooltip="Bajar"
          [disabled]="ultimo"
          (click)="mover(i, 1)"
        >
          <mat-icon>arrow_downward</mat-icon>
        </button>
        <button
          mat-icon-button
          color="warn"
          type="button"
          matTooltip="Quitar pieza"
          (click)="quitar(i)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>

      <div class="campos">
        @switch (b.tipo) {
          @case ("imagen") {
            <mat-form-field appearance="outline">
              <mat-label>Imagen</mat-label>
              <mat-select
                [value]="b.imagen"
                (selectionChange)="cambiar(i, { imagen: $event.value })"
              >
                @for (o of imagenes; track o.id) {
                  <mat-option [value]="o.id">{{ o.label }}</mat-option>
                }
              </mat-select>
              <mat-hint>Se carga en "Imágenes de la categoría".</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Alto (dp)</mat-label>
              <input
                matInput
                type="number"
                min="24"
                max="400"
                [value]="b.alto ?? ''"
                (change)="cambiar(i, { alto: numero($any($event.target).value) })"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Ajuste</mat-label>
              <mat-select
                [value]="b.ajuste"
                (selectionChange)="cambiar(i, { ajuste: $event.value })"
              >
                <mat-option value="contener">Entera, centrada</mat-option>
                <mat-option value="ancho">A todo el ancho</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              matTooltip="Franja de color a todo el ancho detrás de la imagen (por ejemplo, el logo sobre el color del tema)"
            >
              <mat-label>Fondo</mat-label>
              <mat-select
                [value]="tipoFondo(b)"
                (selectionChange)="setTipoFondo(i, $event.value)"
              >
                <mat-option value="nada">Sin fondo</mat-option>
                <mat-option value="tema">Color del tema</mat-option>
                <mat-option value="otro">Otro color</mat-option>
              </mat-select>
            </mat-form-field>
            @if (tipoFondo(b) === "otro") {
              <mat-form-field appearance="outline">
                <mat-label>Color del fondo</mat-label>
                <input matInput readonly [value]="b.colorFondo ?? ''" />
                <ngx-colors
                  matSuffix
                  ngx-colors-trigger
                  [ngModel]="b.colorFondo"
                  [ngModelOptions]="{ standalone: true }"
                  [formats]="['hex']"
                  colorPickerControls="no-alpha"
                  (input)="setColor(i, 'colorFondo', $event)"
                />
              </mat-form-field>
            }
          }

          @case ("botones") {
            <ng-container
              *ngTemplateOutlet="listaTpl; context: { b: b, i: i }"
            ></ng-container>
            <mat-form-field appearance="outline">
              <mat-label>Columnas</mat-label>
              <mat-select
                [value]="b.columnas ?? 1"
                (selectionChange)="cambiar(i, { columnas: $event.value })"
              >
                @for (c of columnas; track c) {
                  <mat-option [value]="c">{{ c }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              matTooltip="Vacío = se calcula según la cantidad de botones y el espacio"
            >
              <mat-label>Alto de cada botón (dp)</mat-label>
              <input
                matInput
                type="number"
                min="40"
                max="360"
                placeholder="Automático"
                [value]="b.alto ?? ''"
                (change)="cambiar(i, { alto: numero($any($event.target).value) })"
              />
              <mat-hint>Vacío = automático.</mat-hint>
            </mat-form-field>
            <mat-checkbox
              [checked]="!!b.expandir"
              (change)="cambiar(i, { expandir: $event.checked })"
              matTooltip="Los botones ocupan todo el espacio que dejan libre las otras piezas"
            >
              Ocupar el espacio libre
            </mat-checkbox>
          }

          @case ("fila") {
            <ng-container
              *ngTemplateOutlet="listaTpl; context: { b: b, i: i, fila: true }"
            ></ng-container>
            <mat-form-field appearance="outline">
              <mat-label>Alto (dp)</mat-label>
              <input
                matInput
                type="number"
                min="40"
                max="160"
                [value]="b.alto ?? ''"
                (change)="cambiar(i, { alto: numero($any($event.target).value) })"
              />
            </mat-form-field>
            @if (
              !sirenas &&
              (lista(b).includes("reflector") || lista(b).includes("sirena"))
            ) {
              <p class="aviso">
                <mat-icon inline>info</mat-icon>
                El cliente no tiene sirenas: reflector y sirena no se van a ver.
              </p>
            }
          }

          @case ("texto") {
            <mat-form-field appearance="outline" class="ancho">
              <mat-label>Texto</mat-label>
              <input
                matInput
                [value]="b.texto ?? ''"
                (change)="cambiar(i, { texto: $any($event.target).value })"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Tamaño (sp)</mat-label>
              <input
                matInput
                type="number"
                min="10"
                max="40"
                [value]="b.tamano ?? ''"
                (change)="cambiar(i, { tamano: numero($any($event.target).value) })"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Color</mat-label>
              <input
                matInput
                readonly
                placeholder="Del tema"
                [value]="b.color ?? ''"
              />
              <ngx-colors
                matSuffix
                ngx-colors-trigger
                [ngModel]="b.color || '#1f2937'"
                [ngModelOptions]="{ standalone: true }"
                [formats]="['hex']"
                colorPickerControls="no-alpha"
                (input)="setColor(i, 'color', $event)"
              />
            </mat-form-field>
            <div class="color">
              @if (b.color) {
                <button
                  mat-icon-button
                  type="button"
                  matTooltip="Usar el color del tema"
                  (click)="cambiar(i, { color: undefined })"
                >
                  <mat-icon>backspace</mat-icon>
                </button>
              }
            </div>
            <mat-checkbox
              [checked]="!!b.negrita"
              (change)="cambiar(i, { negrita: $event.checked })"
            >
              Negrita
            </mat-checkbox>
          }

          @case ("espacio") {
            <mat-form-field appearance="outline">
              <mat-label>Alto (dp)</mat-label>
              <input
                matInput
                type="number"
                min="4"
                max="200"
                [value]="b.alto ?? ''"
                (change)="cambiar(i, { alto: numero($any($event.target).value) })"
              />
            </mat-form-field>
          }
        }
      </div>
    </div>
  }

  <button
    mat-stroked-button
    color="primary"
    type="button"
    [matMenuTriggerFor]="menuTipos"
  >
    <mat-icon>add</mat-icon> Agregar pieza a la pantalla {{ pantalla + 1 }}
  </button>
  <mat-menu #menuTipos="matMenu">
    @for (t of tipos; track t.tipo) {
      <button mat-menu-item type="button" (click)="agregar(t.tipo)">
        <mat-icon>{{ t.icono }}</mat-icon>
        <span>{{ t.label }}</span>
        <span class="menu-desc"> · {{ t.descripcion }}</span>
      </button>
    }
  </mat-menu>
</div>

<!-- Lista ordenada de botones (pieza Botones) o de ítems (pieza Fila). -->
<ng-template #listaTpl let-b="b" let-i="i" let-fila="fila">
  <div class="lista">
    <span class="lista-lbl">
      {{ fila ? "Qué va en la fila (de izquierda a derecha)" : "Botones (en orden)" }}
    </span>
    @for (id of lista(b); track $index; let k = $index, kPrimero = $first, kUltimo = $last) {
      <div
        class="item"
        [class.especial]="esEspecial(id)"
        [class.roto]="!existe(id)"
      >
        <mat-icon class="item-ic">{{
          esEspecial(id) ? "widgets" : "smart_button"
        }}</mat-icon>
        <span class="item-txt">{{ etiqueta(id) }}</span>
        @if (!esEspecial(id) && usadoEnOtra(id); as otra) {
          <span
            class="badge"
            [matTooltip]="
              'Ya está en la pantalla ' +
              otra +
              ': el botón se asigna a la primera donde aparece'
            "
            >también en P{{ otra }}</span
          >
        }
        <span class="flex"></span>
        <button
          mat-icon-button
          type="button"
          [disabled]="kPrimero"
          (click)="moverEnLista(i, k, -1)"
        >
          <mat-icon>{{ fila ? "chevron_left" : "expand_less" }}</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          [disabled]="kUltimo"
          (click)="moverEnLista(i, k, 1)"
        >
          <mat-icon>{{ fila ? "chevron_right" : "expand_more" }}</mat-icon>
        </button>
        <button
          mat-icon-button
          type="button"
          matTooltip="Sacar"
          (click)="quitarDeLista(i, k)"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    } @empty {
      <div class="lista-vacia">
        {{ fila ? "Fila vacía." : "Sin botones: elegí cuáles van acá." }}
      </div>
    }
    <button
      mat-button
      color="primary"
      type="button"
      [matMenuTriggerFor]="menuLista"
    >
      <mat-icon>add</mat-icon>
      {{ fila ? "Agregar a la fila" : "Agregar botón" }}
    </button>
    <mat-menu #menuLista="matMenu">
      @if (fila) {
        @for (e of especialesDisponibles(b); track e.id) {
          <button
            mat-menu-item
            type="button"
            (click)="agregarALista(i, e.id)"
          >
            <mat-icon>widgets</mat-icon>
            <span>{{ e.label }}</span>
            <span class="menu-desc"> · {{ e.nota }}</span>
          </button>
        }
      }
      @for (x of disponibles(b); track x.id) {
        <button mat-menu-item type="button" (click)="agregarALista(i, x.id)">
          <mat-icon [style.color]="x.color || null">smart_button</mat-icon>
          <span>{{ x.nombre }}</span>
          @if (x.funcion) {
            <span class="menu-desc"> · {{ x.funcion }}</span>
          }
        </button>
      } @empty {
        @if (!fila) {
          <div class="menu-vacio">
            No hay más botones. Creá o agregá botones en "Botones de la
            categoría".
          </div>
        }
      }
    </mat-menu>
  </div>
</ng-template>
